var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLandSlowakei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.859,23.778c-2.132,5.148 -7.045,8.856 -12.859,9.242l-2.013,-0c-5.815,-0.386 -10.728,-4.095 -12.86,-9.244c-0.019,-0.047 -0.039,-0.094 -0.058,-0.141l27.849,-0c-0.02,0.047 -0.039,0.095 -0.059,0.143Z",
    fill: "#e42a18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.996,17.613c0.052,-1.85 0.438,-3.616 1.1,-5.241c0.02,-0.048 0.04,-0.097 0.06,-0.145c0.638,-1.518 1.518,-2.909 2.591,-4.125c0.445,-0.505 0.924,-0.979 1.432,-1.42c2.632,-2.281 6.063,-3.662 9.815,-3.662c6.222,0 11.565,3.8 13.836,9.205c0.02,0.049 0.041,0.098 0.061,0.147c0.713,1.748 1.105,3.661 1.105,5.665c0,1.978 -0.383,3.867 -1.078,5.598l-27.849,0c-0.646,-1.607 -1.022,-3.35 -1.073,-5.175l0,-0.847Z",
    fill: "#24356a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.179,6.682c2.632,-2.281 6.063,-3.662 9.815,-3.662c6.222,0 11.565,3.8 13.836,9.205c0.02,0.049 0.041,0.098 0.061,0.147l-27.795,0c0.02,-0.048 0.04,-0.097 0.06,-0.145c0.638,-1.518 1.518,-2.909 2.591,-4.125c0.445,-0.505 0.924,-0.979 1.432,-1.42Z",
    fill: "#f5f5f5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.432,9.623c0.445,-0.505 0.924,-0.979 1.432,-1.42l15.447,-0l-0,12.729c-0,1.724 -0.674,3.115 -1.641,4.224c-0.541,0.621 -1.175,1.154 -1.834,1.607c-2.327,1.6 -4.965,2.205 -4.965,2.205c-0,-0 -3.541,-0.812 -6.036,-3.042c-0.268,-0.24 -0.524,-0.497 -0.763,-0.77c-0.966,-1.109 -1.64,-2.5 -1.64,-4.224l-0,-11.309Z",
    fill: "#f5f5f5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.308,10.08l-0,10.852c0.012,0.694 0.193,1.376 0.527,1.995l12.073,-0c0.338,-0.619 0.519,-1.301 0.527,-1.995l-0,-10.852l-13.127,-0Z",
    fill: "#e42a18"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.56,17.647l-3.751,-0l-0,-1.877l1.875,-0l-0,-1.877l-1.875,-0l-0,-1.877l-1.875,-0l-0,1.877l-1.876,-0l-0,1.877l1.876,-0l-0,1.877l-3.751,-0l-0,1.877l3.751,-0l-0,1.877l1.875,-0l-0,-1.877l3.751,-0l-0,-1.877Z",
    fill: "#f5f5f5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.589,25.566c1.027,0.596 2.13,1.069 3.282,1.408c0.704,-0.176 1.993,-0.645 3.282,-1.408c1.163,-0.623 2.117,-1.537 2.755,-2.639c-0.585,-0.38 -1.281,-0.585 -1.993,-0.587l-0.82,0.117c-0.558,-1.195 -1.828,-1.972 -3.224,-1.972c-1.396,-0 -2.665,0.777 -3.223,1.972c-0.267,-0.069 -0.543,-0.108 -0.82,-0.117c-0.704,-0 -1.407,0.235 -1.993,0.587c0.638,1.102 1.592,2.016 2.754,2.639Z",
    fill: "#24356a"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandSlowakei);
export default __webpack_public_path__ + "static/media/land_slowakei.fed4ccdb0c31b329297ae9a62a2a4be3.svg";
export { ForwardRef as ReactComponent };